import Logo from './Logo.jsx';

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Header/Logo/index.js